import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { isRecord } from "./convertError";
import { ErrorResponse } from "./queriesApi.generated";

export const isFetchBaseQueryError = (
  error: SerializedError | FetchBaseQueryError | undefined | unknown
): error is FetchBaseQueryError => isRecord(error) && error !== undefined && "status" in error;

export const isBioErrorResponse = (error: unknown): error is ErrorResponse => isRecord(error) && "code" in error;
